import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Cuando la ruta cambie, desplázar a la parte superior de la ventana
    window.scrollTo(0, 0);
  }, [pathname]); // Dependencia  se ejecute en cada cambio de ruta

  return null; // no renderiza nada visible
}

export default ScrollToTop;